import { render, staticRenderFns } from "./planning-resource-item.vue?vue&type=template&id=4dc6b4ca&"
import script from "./planning-resource-item.vue?vue&type=script&lang=js&"
export * from "./planning-resource-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports